import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const standards = [
  {
    title: 'Sourcing and verification',
    body: 'We aim to publish stories using credible public information, direct source material, or clearly attributed media. When a report is still developing, we try to label it that way instead of presenting it as settled fact.',
  },
  {
    title: 'Corrections',
    body: 'If a factual error is identified, we review it and update the story when warranted. Readers can contact us with the story link and the specific issue that should be checked.',
  },
  {
    title: 'Headlines and context',
    body: 'We write for speed, but we still aim for headlines and descriptions that accurately reflect the story. We try not to remove important context just to make a headline hit harder.',
  },
  {
    title: 'Advertising independence',
    body: 'Advertising and sponsorship help support the site, but they do not determine which stories we cover or how we frame editorial content.',
  },
];

const EditorialPolicyPage = () => {
  return (
    <div className="min-h-screen bg-black" data-testid="editorial-policy-page">
      <SEO
        title="Editorial Policy"
        description="Editorial standards, sourcing, corrections, and publishing principles for Check On Yo Peoples TV."
        type="website"
      />
      <Header />
      <div className="max-w-5xl mx-auto px-4 py-12 text-gray-300">
        <div className="max-w-3xl mb-8">
          <h1 className="text-4xl sm:text-5xl font-black text-white mb-4">Editorial Policy</h1>
          <p className="text-base sm:text-lg text-gray-300 leading-relaxed">
            Check On Yo Peoples TV publishes fast-moving Cincinnati stories, community updates, and video-led coverage. This page explains the standards we try to follow when we publish, update, and correct our work.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {standards.map((item) => (
            <section key={item.title} className="border border-[#222] bg-[#0d0d0d] p-5" data-testid={`editorial-section-${item.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
              <h2 className="text-white font-bold text-lg mb-2">{item.title}</h2>
              <p className="text-sm text-gray-400 leading-relaxed">{item.body}</p>
            </section>
          ))}
        </div>

        <section className="mt-8 border border-yellow-500/25 bg-yellow-500/10 p-6" data-testid="editorial-contact-panel">
          <h2 className="text-white font-bold text-xl mb-3">How to request a review or correction</h2>
          <p className="text-sm text-gray-300 leading-relaxed">
            Email <a href="mailto:contact@coyp.me" className="text-yellow-400 hover:text-yellow-300">contact@coyp.me</a> with the story link, the issue you believe needs attention, and any public-source material that supports your note.
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default EditorialPolicyPage;